import React from 'react';
//import { render } from "react-dom";
//import axios from 'axios';
//import './Harvestoftheday.css';
import './Cartitems.css';
//import {Helmet} from "react-helmet";
//import AuthService from '../Services/auth.service';
import CartService from '../Services/cart.service';
//import {  InputGroup, Input, Button, InputGroupAddon } from "reactstrap";
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';
import RemoveOutlinedIcon from '@mui/icons-material/RemoveOutlined';
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import ReactLoading from 'react-loading';


class Cartitem extends React.Component {
  constructor(props){
    super(props);
        this.state = {
            selectedQty : 1,
            showQty: undefined,
            disabled:'',
            rate:'',
            selectedItem: undefined,
            selectedRate: undefined,
            showLoading:''

        }
    }
    async componentDidMount(){
        this.setState({ selectedItem: this.props.itm.item_code })
        this.setState({ selectedQty: this.props.itm.qty })
        this.setState({ rate: this.props.itm.rate })
    }
    componentDidUpdate(prevState){
     
    }
    
    addQty = async e => {
        e.preventDefault();
        this.setState({showLoading:<ReactLoading type="bars" color="#1ca3e3" height={50} width={35} />})
        await CartService.addQty(this.state.selectedItem, this.state.selectedQty)
            .then(res=>{ 
                this.props.handleUpdate(); 
                this.setState({showLoading:''}) 
            })
        this.setState({ selectedQty: this.state.selectedQty + 1 })        
        
    }
    subQty= async e => {
        e.preventDefault();
        this.setState({showLoading:<ReactLoading type="bars" color="#1ca3e3" height={50} width={35} />})
        await CartService.subQty(this.state.selectedItem, this.state.selectedQty)
            .then(res=>{ 
                
                this.props.handleUpdate();
                 this.setState({showLoading:''}) 
             })
            this.setState({ selectedQty: (this.state.selectedQty > 0 )?this.state.selectedQty - 1 : this.state.selectedQty })
    


    }
    async removeItem (e, itemcode){
        //alert(itemcode)
        const delay = ms => new Promise(res => setTimeout(res, ms));
        e.preventDefault();
        this.setState({showLoading:<ReactLoading type="bars" color="#1ca3e3" height={50} width={35} />})
        await CartService.removeItem(itemcode)
        .then(res=>{ 
            
            this.props.handleUpdate();
             
            this.setState({showLoading:''}) 
         })       
        CartService.update_cart_local()
        CartService.update_cart()
        
      }
      
    render() {
          //console.log(this.props.product)
          
          
    return <div className="row container pb-3 cart-product cart-items-border mb-3 cart-itm-shadow" >    
                    <div className="col-3 col-md-3 text-center">
                        <img src={process.env.REACT_APP_API_URL + this.props.itm.image} style={{maxHeight: 150}}    className="cart-itm-img" alt=""/>
                    </div>
                    <div className="col-6 col-md-6 ">
                        <h3 className="media-title font-weight-semibold mb-0"> <a href="/#"  className="cart-itm-color" data-abc="true">{this.props.itm.item_name}</a> </h3>
                        <ul className="list-inline list-inline-dotted mb-3 mb-lg-2">
                            <li className="list-inline-item"><a href="/#" className="text-muted rupay-font" data-abc="true">{this.props.itm.desc} @ ₹ {this.props.itm.rate}</a></li>
                        </ul>
                        <div className="quantity-input2 d-flex ">
                                    <button className="quantity-input__modifier quantity-input__modifier--left" onClick={this.subQty} addontype="prepend">
                                        &mdash;
                                    </button>
                                    <input className="quantity-input__screen2" type="text" defaultValue={this.state.selectedQty} readOnly />
                                    <button className="quantity-input__modifier quantity-input__modifier--right"  onClick={this.addQty} addontype="append">
                                       &#xff0b;
                                    </button>  
                                </div> 
                    </div>   
                    <div className="col-3 col-md-3 text-right ">
                        <h3 className="mb-0 font-weight-semibold new-head rupay-font">₹ {this.state.rate * this.state.selectedQty}</h3>
                        <br/>
                        <br/>
                        <span ><p><a href="/#" className="cart-itm-color" data-itemcode={this.props.itm.item_code} onClick={(e) => { this.removeItem(e,this.props.itm.item_code);}}    >{this.state.showLoading ? this.state.showLoading :<DeleteOutlinedIcon className="delete"/> }</a></p></span>
                    </div>
                    
                </div>
         }
        }
export default Cartitem;